import React, { useContext } from "react";
import { IonContent, IonPage } from "@ionic/react";
import useFetchCaching from "../../../hooks/useFetchCaching";
import SkeletonList from "../../../components/Skeleton/SkeletonList";
import { ContractDetail } from "../../../types/requestTypes";
import { useParams } from "react-router-dom";
import DetailPageContractInfo from "./ContractInfo";
import UserContext from "../../../context/UserContext";

import styles from "../../../components/SidebarLayout/SidebarLayout.module.scss";

const DetailsPageContract: React.FC = () => {
    const { contractId } = useParams<{ contractId: string }>();
    const { layoutCtx } = useContext(UserContext);
    const { data } = useFetchCaching<ContractDetail>(
        `/admin/contracts/${contractId}`
    );

    return (
        <IonPage>
            <IonContent fullscreen>
                <section className={styles.wrapper}>
                    <aside></aside>

                    <div
                        className={`${styles.card} ${
                            layoutCtx ? styles.mainRestraint : styles.main
                        } `}
                    >
                        <SkeletonList loading={!data} type={"simple"} />

                        {data && <DetailPageContractInfo data={data} />}
                    </div>
                </section>
            </IonContent>
        </IonPage>
    );
};

export default DetailsPageContract;
